import * as React from 'react';

export default ({
  stroke,
  height,
  width,
}: {
  stroke?: string;
  width?: string;
  height?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width || '24'} height={height || '24'} fill="none">
    <path
      stroke={stroke || '#0A132B'}
      strokeLinecap="round"
      strokeWidth="2"
      d="M7 18h2M7 6h2M8 12h8M15 18h2M15 6h2"
    />
    <path stroke={stroke || '#0A132B'} strokeWidth="2" d="M16 18V6M8 18V6" />
  </svg>
);
